document.addEventListener("DOMContentLoaded", () => {
  
  const isProductPage = window.location.pathname.includes("/products/");
  
  function initBuyBtnLogic(container = document) {
    const variantsWrapper = container.querySelector(
      ".product__controls-group.product__variants-wrapper"
    );
    if (!variantsWrapper) return;

    const selectSizeBtn = container.querySelector("[data-select-size]");
    if (!selectSizeBtn) return;

    const resetBtnText = () => {
      selectSizeBtn.textContent = "Add to Cart";
    };

    const children = Array.from(variantsWrapper.children);

    const hasSizeLabel = children.some((childNode) => {
      const label = childNode.querySelector(".product__label");
      return label?.innerText.includes("Size");
    });

    if (!hasSizeLabel) {
      resetBtnText();
      return;
    }

    children.forEach((childNode) => {
      const label = childNode.querySelector(".product__label");

      if (label?.innerText.includes("Size")) {
        const chips = childNode.querySelector(".product__color-chips");
        if (chips) {
          // Delegate the click on the chips container instead of binding each
          // chip individually at load time. A size chip that is disabled on
          // load (out of stock for the initially selected color) can become
          // enabled after the shopper switches color. Per-chip listeners bound
          // at load never covered those chips, so selecting such a size left
          // the button stuck on "Select Size". Delegation covers every chip,
          // including ones enabled later.
          chips.addEventListener("click", (event) => {
            const chip = event.target.closest("[data-button]");
            if (!chip || !chips.contains(chip)) return;
            if (chip.classList.contains("disabled")) return;
            resetBtnText();
          });
        }
      }
    });
  }

  function setupQuickViewObserver(quickViewContainer) {
    if (!quickViewContainer) return;

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          setTimeout(() => {
            const quickProductInner = quickViewContainer.querySelector(".quick-product--right-inner");
            if (quickProductInner) {
              initBuyBtnLogic(quickProductInner);
            }
          }, 100);
          break;
        }
      }
    });

    observer.observe(quickViewContainer, {
      childList: true,
      subtree: false
    });
  }

  if (isProductPage) {
    // Product page scenario
    initBuyBtnLogic(document);

    const quickViewContainer = document.querySelector(".template-product.quick-search-position-right");
    setupQuickViewObserver(quickViewContainer);

    // Adds case for no variant product in class
    if(document.querySelector('.product-form__item--no-variants')){
      document.querySelector('.product-form__item--no-variants').querySelector('[data-select-size]').innerText = "Add to cart";   
    }

  } else {
    // Index/Home scenario
    const quickViewContainer = document.querySelector(".template-index.quick-search-position-right");
    setupQuickViewObserver(quickViewContainer);

    const carouselTriggers = document.querySelectorAll('.carousel__slide [data-quick-shop-trigger="quick-view"]');
    
    if (carouselTriggers.length > 0 && quickViewContainer) {
      carouselTriggers.forEach((trigger) => {
        trigger.addEventListener("click", () => {
          setTimeout(() => {
            const quickProductInner = quickViewContainer.querySelector(".quick-product--right-inner");
            if (quickProductInner) {
              initBuyBtnLogic(quickProductInner);
            }
          }, 150);
        });
      });
    }
  }
});
